import { BaseModel } from "sjs-base-model";
import RiskModel from "./RiskModel";

export default class InsuranceInfoModel extends BaseModel {
    public readonly lifeRisk: RiskModel = new RiskModel({});
    public readonly creditRisk: RiskModel = new RiskModel({});

    constructor(data: Partial<InsuranceInfoModel>) {
        super();

        this.update(data);
    }
}
